"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allMarketplaces = exports.marketplaceOnMultipleRegions = exports.MARKETPLACE_GROUPS = void 0;
var MARKETPLACE_GROUPS;
(function (MARKETPLACE_GROUPS) {
    MARKETPLACE_GROUPS["Global"] = "Global";
    MARKETPLACE_GROUPS["AsiaPacific"] = "Asia Pacific";
    MARKETPLACE_GROUPS["Europe"] = "Europe";
    MARKETPLACE_GROUPS["NorthAmerica"] = "North America";
    MARKETPLACE_GROUPS["SouthAmerica"] = "South America";
})(MARKETPLACE_GROUPS = exports.MARKETPLACE_GROUPS || (exports.MARKETPLACE_GROUPS = {}));
const featureFlaggedMarketPlaces = [];
const globalMarketplaces = [
    {
        group: MARKETPLACE_GROUPS.Global,
        country: "Global",
        name: "vida XL",
        marketplace: "vidaxl",
        parentMarketplace: "mirakl",
    },
];
const asiaPacificMarketplaces = [
    {
        group: MARKETPLACE_GROUPS.AsiaPacific,
        country: "Australia",
        name: "Bunnings",
        marketplace: "bunnings",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.AsiaPacific,
        country: "Taiwan",
        name: "Carrefour (Taiwan)",
        marketplace: "carrefour",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.AsiaPacific,
        country: "Australia",
        name: "Catch",
        marketplace: "catch",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.AsiaPacific,
        country: "Australia",
        name: "ClickCentral",
        marketplace: "clickfrenzy",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.AsiaPacific,
        country: "Australia",
        name: "TradeSquare",
        marketplace: "tradesquare",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.AsiaPacific,
        country: "Australia",
        name: "Westfield Direct",
        marketplace: "scentregroupau",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.AsiaPacific,
        country: "New Zealand",
        name: "Once it",
        marketplace: "onceit",
        parentMarketplace: "mirakl",
    },
];
const europeMarketplaces = [
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Astore Shop",
        marketplace: "astoreshop",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Sweden",
        name: "Afound",
        marketplace: "afound",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Sweden",
        name: "Ahlens",
        marketplace: "ahlens",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Alltricks",
        marketplace: "alltricks",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "ANWB",
        marketplace: "anwb",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "United Kingdom",
        name: "B&Q",
        marketplace: "bandq",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "Blokker",
        marketplace: "blokker",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Belgium",
        name: "Brico BE",
        marketplace: "bricobe",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Brico FR",
        marketplace: "bricofr",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Bricoprive",
        marketplace: "bricoprive",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Carrefour (France)",
        marketplace: "carrefour",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Poland",
        name: "Carrefour (Poland)",
        marketplace: "carrefour",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Spain",
        name: "Carrefour (Spain)",
        marketplace: "carrefour",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "CLEOR",
        marketplace: "cleor",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Conforama",
        marketplace: "conforama",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Germany",
        name: "Conrad",
        marketplace: "conrad",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Spain",
        name: "Coperama",
        marketplace: "coperma",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "United Kingdom",
        name: "Debenhams (UK)",
        marketplace: "debenhamsuk",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Belgium",
        name: "Decathlon",
        marketplace: "decathlon",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Germany",
        name: "Douglas",
        marketplace: "douglas",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Italy",
        name: "eprice",
        marketplace: "eprice",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "fonQ Partners",
        marketplace: "fonq",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "United Kingdom",
        name: "Friends of Joules",
        marketplace: "joules",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "GO Sport",
        marketplace: "gosport",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Grenier Alpin",
        marketplace: "grenieralpin",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Germany",
        name: "Home24",
        marketplace: "home24",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Italy",
        name: "IBS",
        marketplace: "ibs",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Belgium",
        name: "Inno",
        marketplace: "inno",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Intermarche",
        marketplace: "intermarche",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "Kleertjes en Co",
        marketplace: "kleertjesenco",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "La Poste",
        marketplace: "laposte",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "LE BHV / MARAIS",
        marketplace: "lebhvmarias",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "Leen Bakker",
        marketplace: "leenbakker",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "Leroy Merlin (NLD)",
        marketplace: "leroymerlin",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Leroy Merlin (FRA)",
        marketplace: "leroymerlin",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Brico Marche",
        marketplace: "bricomarche",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Maisonette",
        marketplace: "maisonette",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Maty",
        marketplace: "maty",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "METRO.fr",
        marketplace: "metrofr",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Pandacola",
        marketplace: "pandacola",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Spain",
        name: "PcComponentes",
        marketplace: "pccomponents",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Spain",
        name: "Phone House",
        marketplace: "phonehouse",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Plateforme StopCOVID19",
        marketplace: "platformestop19",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Premiere Vision",
        marketplace: "premierevision",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Spain",
        name: "Privalia Spain",
        marketplace: "privaliaspain",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "Praxis NL",
        marketplace: "praxisnl",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Rue Du Commerce",
        marketplace: "rueducommerce",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "United Kingdom",
        name: "Sephora (UK)",
        marketplace: "sephorauk",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "United Kingdom",
        name: "Sprinter",
        marketplace: "sprinter",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Spain",
        name: "Tiendanimal",
        marketplace: "tiendanimal",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Truffaut",
        marketplace: "truffaut",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "UBALDI",
        marketplace: "ubaldi",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Portugal",
        name: "Worten",
        marketplace: "worten",
        parentMarketplace: "mirakl",
    },
    {
        group: "Middle East",
        country: "UAE",
        name: "Carrefour (UAE)",
        marketplace: "carrefour",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Showroomprive",
        marketplace: "showroomprive",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Germany",
        name: "MediaMarkt",
        marketplace: "mediamarktsaturn",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Europe",
        name: "Satair",
        marketplace: "satair",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "E.Leclerc",
        marketplace: "eleclerc",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Galeries Lafayette",
        marketplace: "galerieslafayette",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Green Weez",
        marketplace: "greenweez",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Maisons Du Monde",
        marketplace: "maisonsdumonde",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Nature & Decouvertes",
        marketplace: "naturedecouvertes",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Germany",
        name: "Shop Apotheke",
        marketplace: "shopapotheke",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Germany",
        name: "Hornbach",
        marketplace: "hornbach",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Poland",
        name: "Empik",
        marketplace: "empik",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Spain",
        name: "El Corte Inglés",
        marketplace: "eicorteingles",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Italy",
        name: "Yoox",
        marketplace: "yoox",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "Place de Tendances",
        marketplace: "placedestendances",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "France",
        name: "La Redoute",
        marketplace: "laredoute",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.Europe,
        country: "Netherlands",
        name: "Obelink",
        marketplace: "obelink",
        parentMarketplace: "mirakl",
    },
];
const northAmericaMarketplaces = [
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "Canada",
        name: "Altitude Sports",
        marketplace: "altitudesports",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "Canada",
        name: "Best Buy",
        marketplace: "bestbuy",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "Canada",
        name: "Hudson's Bay",
        marketplace: "hudsonsbayus",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "Canada",
        name: "Reitmans",
        marketplace: "reitmans",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Albertsons",
        marketplace: "albertsons",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Dia & Co",
        marketplace: "dia",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "DKE",
        marketplace: "dke",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Express",
        marketplace: "express",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "J.Crew",
        marketplace: "jcrew",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Motherlyshop",
        marketplace: "motherlyshop",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "NBC Universal",
        marketplace: "nbcuniversal",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Nordstrom",
        marketplace: "nordstromus",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Office Depot",
        marketplace: "officedepot",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Orderve",
        marketplace: "orderve",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Urban Outfitters Inc.",
        marketplace: "urbanoutfitters",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Kroger",
        marketplace: "kroger",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "1800 flowers.com",
        marketplace: "1800flowers",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "ABB",
        marketplace: "abb",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Hewlett Packard Enterprise",
        marketplace: "hewlettpackardenterprise",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Madewell",
        marketplace: "madewell",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Belk",
        marketplace: "belk",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "Mexico",
        name: "Coppel",
        marketplace: "coppel",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Macys",
        marketplace: "macysus",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Verishop",
        marketplace: "verishopus",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Bed Bath & Beyond",
        marketplace: "bedbathandbeyondus",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.NorthAmerica,
        country: "United States",
        name: "Snappy",
        marketplace: "snappygiftsus",
        parentMarketplace: "mirakl",
    },
];
const southAmericaMarketplaces = [
    {
        group: MARKETPLACE_GROUPS.SouthAmerica,
        country: "Brazil",
        name: "Leroy Merlin (Brazil)",
        marketplace: "leroymerlin",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.SouthAmerica,
        country: "Spain",
        name: "Brico Depot",
        marketplace: "bricodepot",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.SouthAmerica,
        country: "Brazil",
        name: "GPA",
        marketplace: "gpa",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.SouthAmerica,
        country: "Chile",
        name: "Ripley (Chile)",
        marketplace: "ripley",
        parentMarketplace: "mirakl",
    },
    {
        group: MARKETPLACE_GROUPS.SouthAmerica,
        country: "Peru",
        name: "Ripley (Peru)",
        marketplace: "ripley",
        parentMarketplace: "mirakl",
    },
];
exports.marketplaceOnMultipleRegions = ["carrefour", "leroymerlin"];
exports.allMarketplaces = [
    ...globalMarketplaces,
    ...asiaPacificMarketplaces,
    ...europeMarketplaces,
    ...northAmericaMarketplaces,
    ...southAmericaMarketplaces,
    ...(process.env.NODE_ENV !== "production" ? featureFlaggedMarketPlaces : []),
];
//# sourceMappingURL=marketplaceConstants.js.map